import React from 'react';
import { dataHooks } from '@wix/data-hooks';
import { Text, Card, TextPriority } from 'wix-ui-tpa/cssVars';
import { classes } from './DeliveryInfoBox.st.css';
import { useLocaleKeys } from '../../../locale-keys/LocaleKeys';
export const DeliveryInfoBoxHooks = dataHooks('DeliveryInfoBox');
const DeliveryInfoBoxInternal = props => {
  const {
    insideTimeSelector,
    instructions,
    deliveryTime,
    isPickup
  } = props;
  const localeKeys = useLocaleKeys();
  if (!instructions) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: insideTimeSelector ? classes.insideTimeSelector : classes.root
  }, /*#__PURE__*/React.createElement(Card, {
    "data-hook": DeliveryInfoBoxHooks.root(),
    className: classes.card
  }, /*#__PURE__*/React.createElement(Card.Container, null, isPickup && deliveryTime && /*#__PURE__*/React.createElement(Text, {
    "data-hook": DeliveryInfoBoxHooks.deliveryTimeDetails(),
    priority: TextPriority.secondary,
    className: classes.deliveryTime
  }, deliveryTime), /*#__PURE__*/React.createElement(Text, {
    tagName: "h4",
    "data-hook": DeliveryInfoBoxHooks.instructionsTitle(),
    priority: TextPriority.primary,
    className: classes.title
  }, isPickup ? localeKeys.deliverySection.pickupDetails.instructions.title() : localeKeys.deliverySection.deliveryDetails.instructions.title()), /*#__PURE__*/React.createElement(Text, {
    "data-hook": DeliveryInfoBoxHooks.instructionsDetails(),
    priority: TextPriority.secondary,
    className: classes.instructions
  }, instructions))));
};
export const DeliveryInfoBox = /*#__PURE__*/React.memo(DeliveryInfoBoxInternal);
//# sourceMappingURL=DeliveryInfoBox.js.map